import { TranslationKeys } from '~/common/types';
import { IPricingConfigurationType, IRimType } from '~/purchase/types';

export const PRICING_CONFIGURATION_TYPE_LABEL_LOOKUP: Record<
  IPricingConfigurationType,
  keyof TranslationKeys
> = {
  DISCOUNT_BF: 'app.quote.pricing_configuration_type.discount_bf',
  MARGIN: 'app.quote.pricing_configuration_type.margin',
  NET_MARGIN: 'app.quote.pricing_configuration_type.net_margin',
};
export const RIM_TYPE_LABEL_LOOKUP: Record<IRimType, keyof TranslationKeys> = {
  ALLOY: 'app.quote.rim_type.alloy',
  STEEL: 'app.quote.rim_type.steel',
};
